export default "/fonts/vendor/katex/dist/KaTeX_Math-Italic.woff2?6d3d25f4820d0da8f01fa3d2c7cbb8c2";